import script from "./sf-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-modal.vue?vue&type=script&setup=true&lang=ts"

import "./sf-modal.vue?vue&type=style&index=0&id=9a895bc0&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a895bc0"]])

export default __exports__